// extracted by mini-css-extract-plugin
export var statItem = "_ks-1";
export var statsRow = "_ks-0";